import * as React from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import TopImage from "../components/common/TopImage";

const sections = [
  {
    title: "AIM",
    description:
      "To inspire a community of learners who positively impact the world through knowledge, compassion, and leadership.",
    image: "A.JPG",
    backgroundColor: "bg-red-400",
  },
  {
    title: "MISSION",
    description:
      "Empowering students with a holistic education that cultivates critical thinking, creativity, and character.",
    image: "B.png",
    backgroundColor: "bg-blue-500",
  },
  {
    title: "VISION",
    description:
      "Fostering lifelong learners through innovation and excellence.",
    image: "C.jpg",
    backgroundColor: "bg-amber-500",
  },
];

const MyComponent=(props)=>{
  return (
    <div>
      <NavBar/>
      <TopImage text="Mission And Vision"/>
      <div className="flex flex-col mx-28 sm:px-5 max-sm:mx-5 mb-10 sm:mb-28 text-black ">
  <div className="self-center mt-20 text-4xl font-bold tracking-wider max-md:max-w-full max-sm:max-w-full">
    Motherland Children Academy
  </div>
  <div className="mt-8 max-sm:mt-16 text-gray-700 w-full text-base tracking-wide text-justify max-md:mt-10 max-md:max-w-full max-sm:max-w-full">
<div >
Education transforms people into individuals who make choices wisely and courageously under any circumstance. It equips children with the ability to choose between wisdom and foolishness, good and bad deeds, regardless of the academic degree they possess. Good education embellishes the personality of a student. It inspires the child to develop his/her hidden talents and mould his/her character to perfection. It is the quintessence of a harmonious growth of the mind, body and senses.

</div>
    <br />
    Keeping all these aspects of modern education in mind, Motherland Children Academy has created an educational ecosystem that can make all these aspects a reality. We are committed to preparing young minds to become responsible citizens capable of building a prosperous nation. A co-educational school that imparts education through the medium of English, it is one of the most prestigious institutions managed by the Motherland Education Society. The school, affiliated to CBSE, provides a sound education through a well-designed curriculum and helps students develop physically, intellectually, and morally. Ultimately, our aim is to enable our students to find their place in the challenging world of tomorrow.
  </div>
</div>

    <div className="flex flex-col mb-20">
      {sections.map((section, index) => (
        <div
          key={index}
          className={`flex justify-center items-center px-16 py-6 mt-10 w-full ${section.backgroundColor} max-md:px-5 max-md:max-w-full`}
        >
          <div className="w-full max-md:max-w-full">
            <div className="flex gap-16 py-12 max-md:flex-col max-md:gap-0 max-md:">
              <div
                className={`flex flex-col w-[60%] max-md:ml-0 max-md:w-full ${
                  index % 2 === 0 ? "ml-5" : " gap-2"
                }`}
              >
                <div className="flex lg:translate-y-1/2 flex-col ml-16 text-white  max-md:mt-10">
                  <div className="text-5xl font-bold tracking-wider max-md:text-4xl">
                    {section.title}
                  </div>
                  <div className="mt-10  text-3xl tracking-wide">
                    {section.description}
                  </div>
                </div>
              </div>
              <div
                className={`flex flex-col w-[54%] max-md:ml-0 max-md:w-full ${
                  index % 2 === 0 ? "order-1" : ""
                }`}
              >
                <img
                  loading="lazy"
                  src={`${process.env.PUBLIC_URL}/assets/MissionAndVision/${section.image}`}
                  alt={`Image ${index + 1}`}
                  className=" mr-44 shadow-sm rounded-2xl aspect-square  max-md:mt-8 max-md:ml-16 max-md:w-60  "/>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
    <Footer/>
    </div>
  );
}

export default MyComponent;
